import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import Icon from './icon';

export default function Approvers({ tasks }) {
  const approverNames = useMemo(() => {
    const approverNames = new Set();
    for (const task of tasks) {
      if (task.approver) {
        approverNames.add(task.approver.name);
      } else {
        // Approver was not always persisted - fall back to assignees
        for (const assignee of task.assignees) {
          approverNames.add(assignee.name);
        }
      }
    }
    return approverNames;
  }, [tasks]);

  return (
    <div className="d-flex me-5">
      <Icon className="bg-success" icon={faCheck} />
      <div className="ms-2">
        <b className="text-nowrap">Approved by</b>
        {[...approverNames].map((name, i) => (
          <div className="mt-2 text-nowrap" key={i}>{name}</div>
        ))}
      </div>
    </div>
  );
}

Approvers.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.shape({
    approver: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    assignees: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    roles: PropTypes.arrayOf(PropTypes.string),
    stepIndex: PropTypes.number.isRequired,
  })).isRequired,
};
